import { render, staticRenderFns } from "./search-box-assessment.vue?vue&type=template&id=02db84f1&scoped=true"
import script from "./search-box-assessment.vue?vue&type=script&lang=js"
export * from "./search-box-assessment.vue?vue&type=script&lang=js"
import style0 from "./search-box-assessment.vue?vue&type=style&index=0&id=02db84f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db84f1",
  null
  
)

export default component.exports